require( 'intersection-observer' );
import { Helper } from '../../../js/util/helper';

export default class ImageSlider {
  constructor( node ) {
    this.node = node;
    this.elementHeight = this.node.offsetHeight;
    this.viewportHeight = Math.max( document.documentElement.clientHeight, window.innerHeight || 0 );
    this.scrollFunction = this.windowScroll.bind( this );
    this.windowResize();
    this.windowScroll();
    this.createIntersectionObserver();
  }
  windowResize() {
    window.addEventListener( 'resize', Helper.debounce(() => {
      this.viewportHeight = Math.max( document.documentElement.clientHeight, window.innerHeight || 0 );
      this.windowScroll();
    }, 250 ));
  }
  windowScroll() {
    let pos = this.node.getBoundingClientRect().top + this.elementHeight;
    let totalHeight = this.node.offsetHeight + this.viewportHeight;
    let h = this.node.children[ 0 ].offsetHeight - this.elementHeight;
    let percent = ( pos * 100 ) / totalHeight;
    let top = ( Math.floor(( h * ( 100 - percent )) / 100 )) * -1;

    if ( top <= 0 && top >= ( h * -1 )) {
      window.requestAnimationFrame(() => {
        this.node.children[ 0 ].style.top = top + 'px';
      });
    }
  }
  handleIntersectionObserver( entries ) {
    entries.forEach( entry => {

      // let scrollFunction = this.windowScroll.bind( this );

      if ( entry.isIntersecting ) {
        window.addEventListener( 'scroll', this.scrollFunction, true );
      } else if ( !entry.isIntersecting ) {
        window.removeEventListener( 'scroll', this.scrollFunction, true );
      }
    });
  }
  createIntersectionObserver() {
    let observer;

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    let callFunction = this.handleIntersectionObserver.bind( this );

    observer = new IntersectionObserver( callFunction, options );
    observer.observe( this.node );
  }
}
